import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaGithub, FaLinkedin } from "react-icons/fa6";
import emailjs from "@emailjs/browser";
import cvData from "../data/cvData";
import "./Footer.css";

export default function Footer({ onCalendlyClick = () => {} }) {
  const year = new Date().getFullYear();
  const { contacts, location, name, title } = cvData;
  const formRef = useRef(null);
  const [formStatus, setFormStatus] = useState({ state: "idle", message: "" });

  const emailJsServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || "YOUR_SERVICE_ID";
  const emailJsTemplateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "YOUR_TEMPLATE_ID";
  const emailJsPublicKey = "SqnD7Z2Ub11QXHwaR";
  const isEmailConfigured = emailJsServiceId !== "YOUR_SERVICE_ID" && emailJsTemplateId !== "YOUR_TEMPLATE_ID";

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isEmailConfigured) {
      setFormStatus({ state: "error", message: "Email service is not configured yet." });
      return;
    }

    setFormStatus({ state: "sending", message: "Sending..." });
    emailjs
      .sendForm(emailJsServiceId, emailJsTemplateId, formRef.current, {
        publicKey: emailJsPublicKey,
      })
      .then(() => {
        setFormStatus({ state: "success", message: "Message sent! I'll reply soon." });
        formRef.current?.reset();
      })
      .catch(() => {
        setFormStatus({
          state: "error",
          message: "Could not send right now. Please try again or use another channel.",
        });
      });
  };

  return (
    <footer className="site-footer">
      <div className="footer-cta">
        <p className="eyebrow">Let's make something</p>
        <h3>Ready to build your next digital experience?</h3>
        <div className="footer-cta-actions">
          <button className="footer-btn primary" type="button" onClick={onCalendlyClick}>
            Schedule a call
          </button>
          <a className="footer-btn ghost" href={`mailto:${contacts.email}`}>
            Email Hirun
          </a>
        </div>
      </div>

      <div className="footer-grid">
        <div>
          <h4>Contact</h4>
          <a href={`mailto:${contacts.email}`}>{contacts.email}</a>
          <a href={`tel:${contacts.phone.replace(/\s/g, "")}`}>{contacts.phone}</a>
          <p>{location}</p>
        </div>
        <div>
          <h4>Explore</h4>
          <Link to="/about">About</Link>
          <Link to="/experience">Experience</Link>
          <Link to="/portfolio">Projects</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div>
          <h4>Social</h4>
          <div className="footer-socials">
            <a href={contacts.github || "https://github.com/hirun-kolongahapitiya"} target="_blank" rel="noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={contacts.linkedin || "https://www.linkedin.com/in/hirun-kolongahapitiya/"} target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href={`mailto:${contacts.email}`} aria-label="Email Hirun">
              <FaEnvelope />
            </a>
          </div>
        </div>
        <div>
          <form ref={formRef} className="footer-social-form" onSubmit={handleSubmit}>
            <div className="footer-form-header">
              <img
                src="/assets/profile.jpg"
                alt={`${name || "Hirun Kolongahapitiya"} portrait`}
                loading="lazy"
              />
              <div>
                <strong>{name}</strong>
                <span>{title}</span>
              </div>
            </div>
            <div className="footer-form-row">
              <input type="text" name="from_name" placeholder="Full Name" required />
              <input type="email" name="reply_to" placeholder="Email Address" required />
            </div>
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              autoComplete="tel"
              inputMode="tel"
            />
            <textarea name="message" placeholder="Your Message" required rows="3"></textarea>
            <input type="hidden" name="title" value="Portfolio Contact" />
            <button type="submit" disabled={formStatus.state === "sending"}>
              {formStatus.state === "sending" ? "Sending..." : "Send Message"}
            </button>
            {formStatus.message && (
              <p
                className={`footer-form-status ${
                  formStatus.state === "success" ? "success" : formStatus.state === "error" ? "error" : ""
                }`}
              >
                {formStatus.message}
              </p>
            )}
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} Hirun Kolongahapitiya. All rights reserved.</span>
        <span>Crafted in Sri Lanka with curiosity.</span>
      </div>
    </footer>
  );
}
